import { ref, computed } from 'vue'

// Global state for i18n
const currentLocale = ref('en-us')
const translations = ref({})

// Translation function
export function useI18n() {
  const t = (key, fallback = key) => {
    const keys = key.split('.')
    let value = translations.value[currentLocale.value]
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        return fallback
      }
    }
    
    return typeof value === 'string' ? value : fallback
  }

  const setLocale = (locale) => {
    currentLocale.value = locale
  }

  const loadTranslations = (localeTranslations) => {
    translations.value = { ...translations.value, ...localeTranslations }
  }

  const locale = computed(() => currentLocale.value)

  return {
    t,
    locale,
    setLocale,
    loadTranslations
  }
}

// Default translations
const defaultTranslations = {
  'en-us': {
    header: {
      logoAlt: 'Trails of Hooves',
      menuToggle: 'Toggle navigation menu'
    }
  },
  'nl-nl': {
    header: {
      logoAlt: 'Trails of Hooves',
      menuToggle: 'Navigatiemenu aan/uit'
    }
  }
}

// Initialize with default translations
const { loadTranslations } = useI18n()
loadTranslations(defaultTranslations)
